import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";

class FeedbackTemplateList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      searchText: "", 
      listData: [],
      deleting:false,
      selectedRow:null,
      listPageSettings: {
        Title: "Feedback Templates",
        Search: {
          hideFilter: true,
          showSearch: true,
          placeholder: "Search by feedback title",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
        },
        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
        ],
        Columns: [
          {
            Name: "Title",
            Type: "field",
            Columns: [{ Column: "Title" }]
          },
            {
            Name: "Description",
            Type: "field",
            Columns: [{ Column: "Description" }]
          }
        ],
          RowButtons: [
          { ButtonType: "ImageButton", Type: "edit", Text: "Edit", Icon: "edit", Action: "edit",},
          { ButtonType: "ImageButton", Type: "delete", Text: "Delete", Icon: "delete", Action: "delete" }
        ],
      }
    };
  }

  componentDidMount() {
    this.loadData();
  }

    onRowButtonClicked = (btn, row) => {

    if (btn.Action === "edit") {

         this.props.history.push({
                        pathname:"/home/feedback/template/create",
                        state: { data: row }
                      });

    }

    if (btn.Action === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageSize !== this.state.pageSize
    ) {
      this.loadData();
    }
  }

  // ======================
  // LOAD DATA
  // ======================

  loadData = async () => {
    this.setState({ loading: true });
    const { searchText } = this.state;

    try {
      let response = await this.props.getFeedbacks();
      let list = []; // Declare list variable properly
      
      if (response.code === "0") {
        list = response.data;
      } else {
        alert("Failed to fetch feedback");
        list = [];
      }

      // Apply search filter
      let filteredChannels = list; // Use list variable here
      if (searchText && searchText.length >= 3) {
        filteredChannels = filteredChannels.filter(channel => 
          channel.Title && channel.Title.toLowerCase().includes(searchText.toLowerCase())
        );
      }

      this.setState({
        list: filteredChannels || [],
        totalCount: filteredChannels ? filteredChannels.length : 0,
        loading: false
      });
    } catch (error) {
      console.log(error);
      this.setState({ 
        loading: false,
        list: [],
        totalCount: 0
      });
    }
  };

  // ======================
  // PAGINATION
  // ======================

  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 });
    }
  };

  onPreviousClick = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 });
    }
  };

  onFirstClick = () => this.setState({ page: 1 });

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages });
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({
      pageSize: Number(size),
      page: 1
    });
  };

  // ======================
  // HEADER BUTTONS
  // ======================

  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new") {
      this.props.history.push({
        pathname: "/home/feedback/template/create",
      });
    }
  };

  // ======================
  // SEARCH
  // ======================

  onSearch = (searchText) => {
    this.setState({ searchText }, () => {
      this.loadData();
    });
  };

  onRefreshClick = () => {
    this.loadData();
  };

  onPageChange = (page, pageSize) => {
    console.log("page", page);
    this.setState(
      { page, pageSize },
      () => {
        this.loadData();
      }
    );
  };

    deleteRecord = async() => {
      try{
      this.setState({
        deleting:true
      })
      const response=await this.props.deleteFeedback(this.state.selectedRow.key);
      if(response.code=="0"){
        alert("feedback template delete successfully");
      
      }
      else{
       alert("failed to delete feedback template");
      }
        this.setState({
          deleting:false,
           showDelete: false,
          selectedRow: null
        },this.loadData);
      }
      catch(error){
         alert("failed to delete feedback template");
          this.setState({
          deleting:false,
           showDelete: false,
          selectedRow: null
        },this.loadData);
      }
  };

  render() {
    return (
      <>
        <ListingPage
          {...this.props}
          onPageChange={this.onPageChange}
          listPageSettings={this.state.listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
              onRowButtonClicked={this.onRowButtonClicked}
        />
         {this.state.showDelete && (
          <Window
            header={"Delete"}
            size="medium"
            modal={true}
            processing={
              this.state.deleting
            }
            onClose={() =>
              this.setState({
                showDelete: false
              })
            }
            onButtonClick={(buttonType) => {
              if (
                buttonType.toLowerCase() === "yes"
              ) {
                this.deleteRecord();
              } else {
                this.setState({
                  showDelete: false,
                  selectedRow: null
                });
              }
            }}
            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              },
            ]}
          >
            <div>
              Are you sure you wish to delete this record?
            </div>
          </Window>
        )}
      </>
    );
  }
}

export default FeedbackTemplateList;